import React, {Fragment} from "react";
import UserSessionService from "../../services/UserSessionService";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import "@sendbird/uikit-react/dist/index.css";
import ChatConversationService from "../../services/chat/ChatConversationService";
import ViewHeaderComponent from "../../components/ViewHeaderComponent";
import {withRouter} from "react-router";
import * as DateUtil from "../../utils/DateUtil";
import ConversationCard from "../../components/chat/ConversationCard";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import QueryStringUtils from "../../utils/QueryStringUtils";
import "scss/Chat.css";

class ChatsOpen extends React.Component {


    constructor(props) {
        super(props);

        this.chatRefreshInterval = process.env.REACT_APP_CHAT_PAGE_REFRESH_INTERVAL * 1000;


        this.props.changeHeader("Chat");

        let resourceType = QueryStringUtils.getQueryStringValue('rt');
        let resourceId = QueryStringUtils.getQueryStringValue('ri');
        let hasContext = !!resourceType && !!resourceId;

        this.state = {
            isLoading: true,
            gotChatUser: false,
            gotConversations: false,
            gotOpenConversations: false,
            gotClosedConversations: false,
            shouldRenderOpenConversations: true,
            shouldRenderClosedConversations: false,
            user: UserSessionService.getUser().user,
            resourceType:resourceType,
            resourceId:resourceId,
            hasContext: hasContext

        }

        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
        this.interval = setInterval(this.loadData, this.chatRefreshInterval);
    }

    loadData() {
        let newState = {
            isLoading: false,
            lastRefresh: DateUtil.getCurrentTimestamp()
        };
        let initialPromises = [];

        let conversationsIndex = initialPromises.length;
        if(this.state.hasContext){
            initialPromises[conversationsIndex] = ChatConversationService.retrieveOpenForUserAndContext(this.state.user.id, this.state.resourceType, this.state.resourceId);
        }else {
            initialPromises[conversationsIndex] = ChatConversationService.retrieveOpenForUser(this.state.user.id);
        }

        Promise.all(initialPromises).then(
            initialResponses => {
                newState.gotConversations = initialResponses[conversationsIndex] && initialResponses[conversationsIndex].length > 0;
                newState.conversations = initialResponses[conversationsIndex];
                this.setState(newState)
            }
        )
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        if (this.state.isLoading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>
                <div className={"chatContainer"}>
                    <SFXButtonComponent onClick={()=> {this.props.history.push("/chat/history")}} className={"btn btn-primary pull-right"}>
                        View History
                    </SFXButtonComponent>

                    <ViewHeaderComponent>
                        Open Chats
                        <br/>
                        <span style={{fontSize: "9pt", fontWeight: "normal", color: "#686868"}}>
                            Last checked at {this.state.lastRefresh}
                        </span>
                    </ViewHeaderComponent>

                    {this.renderConversations()}
                </div>
            </Fragment>

    }

    renderConversations() {
        if (!this.state.gotConversations) {
            return <Fragment>
                No Chats Found
            </Fragment>
        }

        return <Fragment>
            {
                this.state.gotConversations &&
                <Fragment>
                    {
                        this.state.conversations.map(conversation => {
                            return this.renderConversation(conversation, false);
                        })
                    }
                </Fragment>
            }
        </Fragment>
    }

    renderConversation(conversation) {
        return <ConversationCard key={conversation.id}
                                 {...this.props}
                                 conversation={conversation}
        />
    }
}

export default withRouter(ChatsOpen)